const loadSessionItem = (key)  => {
  try {
    const serializedState = sessionStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
      return undefined
  }
};

const saveSessionItem = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    sessionStorage.setItem(key, serializedState);
  } catch (err) {
    // Ignoring write error as of now
  }
};

const clearSessionItem = (key) => {
  try {
    sessionStorage.removeItem(key);
    return true;
  } catch (err) {
    return false;
  }
};

module.exports = {
  loadSessionItem,
  saveSessionItem,
  clearSessionItem
}